import { Injectable } from '@angular/core';
import { EnumLanguage } from '@libs/constants';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
	providedIn: 'root'
})
export class AddonLanguageTranslationService {

	//0 - subject to hold the language
	private translate$: BehaviorSubject<EnumLanguage> = new BehaviorSubject<EnumLanguage>(EnumLanguage.EN);

	//1 - set language
	translate(language: EnumLanguage): void {
		this.translate$.next(language);
	}

	//2 - get the subject as observable to subscribe on reaction
	getTranslationObservable(): Observable<EnumLanguage> {
		return this.translate$.asObservable();
	}

	//3 - close the subject
	unsubscribe(): void {
		this.translate$.unsubscribe();
	}
}
